// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetNoticeOfIntentChangeRequestByCipReclassificationHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ChangeRequestDTO from '../models/ChangeRequestDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    institutionId: string | null;
    changeRequestId: string | null | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            institutionId: '00000000-0000-0000-0000-000000000000',
            changeRequestId: null,
        },
        initValues);
    },
    institutionId: 'institutionId',
    changeRequestId: 'changeRequestId',
}

interface Result extends ResultDTO {
    changeRequests: ChangeRequestDTO[] | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            changeRequests: [],
        },
        initValues);
    },
    changeRequests: 'changeRequests',
}

export { Request, Result };